import { IconLibrary } from '../library';
import { getBasePath } from '../../../utilities/base-path';

/**
 * Currently the getBasePath() utility functions for local instances of
 * storybook and for the main site. However there are edge cases, including
 * the hosted version of storybook where a different path is required. Making
 * this async allows multiple to be supported concurrently. Importantly, the
 * main site path is tried first, so as to not impact performance.
 *
 * Directory structure on site (currently)
 * /themes/custom/outline_theme/dist/components/library.custom/library.custom.js
 * /dist/vectors/DEMO-feather.svg
 *
 * Directory structure on storybook
 * /src/components/outline-icon/libraries/library.custom.ts
 * /vectors/DEMO-feather.svg
 *
 *
 */

const library: IconLibrary = {
  name: 'custom',
  resolver: name => {
    const basePath = getBasePath();
    const basePath2 = getBasePath('/themes/custom/outline_theme/dist/vectors/');
    const paths = [
      `${basePath}/vectors/${name}.svg`,
      `${basePath2 + name}.svg`,
    ];

    // Cache for successful icon lookups
    const iconCache = new Map<string, string>();
    // Set to keep track of warned paths
    const warnedPaths = new Set<string>();

    return async () => {
      // Check cache first
      if (iconCache.has(name)) {
        return iconCache.get(name) || '';
      }

      for (const path of paths) {
        try {
          const response = await fetch(path, { method: 'HEAD' });
          if (response.ok) {
            iconCache.set(name, path);
            return path;
          } else if (!warnedPaths.has(path)) {
            console.warn(
              `<outline-icon> path not working: ${path}, fallback paths will be attempted. See library.custom.ts for more information.`
            );
            warnedPaths.add(path);
          }
        } catch (error) {
          if (!warnedPaths.has(path)) {
            console.warn(
              `<outline-icon> failed to fetch from path: ${path}, fallback paths will be attempted. See library.custom.ts for more information.`,
              error
            );
            warnedPaths.add(path);
          }
        }
      }

      console.error(
        `<outline-icon> failed to load: ${name}. See library.custom.ts`
      );
      iconCache.set(name, ''); // Cache the failure
      return '';
    };
  },

  // Mutator intentionally disabled to facilitate multicolor or brand-specific vectors. Turning this on will set all fills to 'currentColor'.
  // mutator: svg => svg.setAttribute('fill', 'currentColor'),
};

export default library;
